import { useFormContext } from 'react-hook-form';
import { DashboardPageFormField } from '@shigo-ui/dashboard-ui';
import { Input } from '@shigo-ui/ui';

import type { DemandPartnerFormValue } from '../../formSchema';

type DemandPartnerNumberFieldName =
  | 'additionalCost'
  | 'biddingBidTTL'
  | 'biddingTmax'
  | 'ioCpmCostValue'
  | 'revenueCap'
  | 'revShareValue';

export function DemandPartnerNumberField(props: {
  name: DemandPartnerNumberFieldName;
  label: string;
  hint?: string;
  required?: boolean;
  prefix?: string;
  suffix?: string;
  min?: number;
  step?: number;
}) {
  const { register, formState } = useFormContext<DemandPartnerFormValue>();
  const error = formState.errors[props.name]?.message;
  let inputClassName: string | undefined;
  if (props.prefix) inputClassName = 'pl-7';
  else if (props.suffix) inputClassName = 'pr-12';

  return (
    <DashboardPageFormField
      label={props.label}
      required={props.required}
      hint={props.hint}
      error={error}
    >
      <div className="relative">
        {props.prefix ? (
          <span
            className="text-muted-foreground pointer-events-none absolute inset-y-0 left-3 flex items-center text-sm"
            aria-hidden="true"
          >
            {props.prefix}
          </span>
        ) : null}
        <Input
          type="number"
          min={props.min}
          step={props.step}
          className={inputClassName}
          {...register(props.name, { valueAsNumber: true })}
        />
        {props.suffix ? (
          <span
            className="text-muted-foreground pointer-events-none absolute inset-y-0 right-3 flex items-center text-sm"
            aria-hidden="true"
          >
            {props.suffix}
          </span>
        ) : null}
      </div>
    </DashboardPageFormField>
  );
}
